import React from "react";
import { CertificateDocument } from "../../modules/PdfGenerator/CertificateDocument";

const CertificateCard = ({ item, keyPrefix }) => (
  <figure className="home-cert-showcase__card" aria-hidden>
    <div className="home-cert-showcase__card-cert">
      <div className="home-cert-showcase__card-cert-inner">
        <CertificateDocument
          certificateData={item.certificateData}
          certificateId={`${keyPrefix}-${item.id}`}
        />
      </div>
    </div>
    <figcaption className="home-cert-showcase__card-title">
      {item.title}
    </figcaption>
  </figure>
);

export const CertificateMarqueeRow = ({
  items,
  direction = "right",
  row = "top",
}) => {
  const directionClass =
    direction === "left"
      ? "home-cert-showcase__rail--left"
      : "home-cert-showcase__rail--right";
  const viewportClass =
    row === "bottom"
      ? "home-cert-showcase__viewport home-cert-showcase__viewport--bottom"
      : "home-cert-showcase__viewport home-cert-showcase__viewport--top";

  return (
    <div className={viewportClass} aria-hidden>
      <div className={`home-cert-showcase__rail ${directionClass}`}>
        {items.map((item) => (
          <CertificateCard key={item.id} item={item} keyPrefix={row} />
        ))}
        {items.map((item) => (
          <CertificateCard
            key={`${item.id}-duplicate`}
            item={item}
            keyPrefix={`${row}-dup`}
          />
        ))}
      </div>
    </div>
  );
};
